import type { AuctionDTO } from 'models/dtos'

type UniversalAuctionDetail = {
  auctionStartDateTime: AuctionDTO['auctionStartDateTime']
  no: string
  entityId: string
  passingOrderNo: number
  licensePlate: string
  color: string
  type: string | null
  id: string | null
  dateFirstReg: string
  version: string | null
  mileage: number | null
  coteArgusPriceDate: number | null
  coteArgusKm: number | null
  nbPassage: number | null
  tvaRecuperable: boolean | null
  observationsVendeur: string | null
  referenceVendeur: string | null
  withdrawalPrice: number | null
  reserveTTCHF: number | null
  estimationApporteur: number | null
  bidPrice: number | null
}

const defaultUniversalAuctionDetail: UniversalAuctionDetail = {
  auctionStartDateTime: null,
  no: '',
  entityId: '',
  passingOrderNo: 0,
  licensePlate: '',
  color: '',
  type: null,
  dateFirstReg: '',
  id: null,
  version: null,
  estimationApporteur: null,
  coteArgusPriceDate: null,
  coteArgusKm: null,
  reserveTTCHF: null,
  mileage: null,
  observationsVendeur: null,
  referenceVendeur: null,
  tvaRecuperable: null,
  withdrawalPrice: null,
  nbPassage: null,
  bidPrice: null,
}

export type { UniversalAuctionDetail }
export { defaultUniversalAuctionDetail }
